import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  charCodeAt1yspne1d8erbm as charCodeAt,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  toString3o7ifthqydp6e as toString,
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import {
  split3d3yeauc4rm2n as split,
  contains3ue2qo8xhmpf1 as contains,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { termShouldUseFuzzySearch1p8g0yvn86xll as termShouldUseFuzzySearch } from './termShouldUseFuzzySearch.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function fromString$register(building, isReject, reject, exact, loose, exactMode) {
  if (building.a() === 0)
    return Unit_instance;
  var str = building.toString();
  building.ch();
  if (isReject._v) {
    // Inline function 'kotlin.collections.plusAssign' call
    reject.v(str);
  } else if (exactMode) {
    // Inline function 'kotlin.collections.plusAssign' call
    exact.v(str);
  } else {
    // Inline function 'kotlin.collections.plusAssign' call
    loose.v(str);
  }
  isReject._v = false;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      y3r(string) {
        var exact = HashSet().ha();
        var loose = HashSet().ha();
        var reject = HashSet().ha();
        var inQuotes = false;
        var isReject = {_v: false};
        var building = StringBuilder().d1();
        var inductionVariable = 0;
        var last = string.length;
        while (inductionVariable < last) {
          var char = charCodeAt(string, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          if (inQuotes) {
            if (char === _Char___init__impl__6a9atx(34)) {
              inQuotes = false;
              fromString$register(building, isReject, reject, exact, loose, true);
            } else {
              // Inline function 'kotlin.text.lowercaseChar' call
              // Inline function 'kotlin.text.lowercase' call
              // Inline function 'kotlin.js.asDynamic' call
              // Inline function 'kotlin.js.unsafeCast' call
              var tmp$ret$2 = toString(char).toLowerCase();
              var tmp$ret$3 = charCodeAt(tmp$ret$2, 0);
              building.xb(tmp$ret$3);
            }
          } else {
            if (char === _Char___init__impl__6a9atx(32)) {
              fromString$register(building, isReject, reject, exact, loose, false);
            } else if (char === _Char___init__impl__6a9atx(34)) {
              inQuotes = true;
            } else if (char === _Char___init__impl__6a9atx(45))
              if (building.a() > 0)
                building.xb(char);
              else {
                isReject._v = true;
              }
             else {
              // Inline function 'kotlin.text.lowercaseChar' call
              // Inline function 'kotlin.text.lowercase' call
              // Inline function 'kotlin.js.asDynamic' call
              // Inline function 'kotlin.js.unsafeCast' call
              var tmp$ret$6 = toString(char).toLowerCase();
              var tmp$ret$7 = charCodeAt(tmp$ret$6, 0);
              building.xb(tmp$ret$7);
            }
          }
        }
        fromString$register(building, isReject, reject, exact, loose, false);
        return new (TextQuery())(exact, loose, reject);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function levenshtein($this, lhs, rhs) {
  if (equals(lhs, rhs)) {
    return 0;
  }
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(lhs) === 0) {
    return charSequenceLength(rhs);
  }
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(rhs) === 0) {
    return charSequenceLength(lhs);
  }
  var lhsLength = charSequenceLength(lhs) + 1 | 0;
  var rhsLength = charSequenceLength(rhs) + 1 | 0;
  var tmp = 0;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_0 = Array(lhsLength);
  while (tmp < lhsLength) {
    var tmp_1 = tmp;
    tmp_0[tmp_1] = tmp_1;
    tmp = tmp + 1 | 0;
  }
  var cost = tmp_0;
  var tmp_2 = 0;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_3 = Array(lhsLength);
  while (tmp_2 < lhsLength) {
    tmp_3[tmp_2] = 0;
    tmp_2 = tmp_2 + 1 | 0;
  }
  var newCost = tmp_3;
  var inductionVariable = 1;
  if (inductionVariable < rhsLength)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      newCost[0] = i;
      var inductionVariable_0 = 1;
      if (inductionVariable_0 < lhsLength)
        do {
          var j = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var match = charSequenceGet(lhs, j - 1 | 0) === charSequenceGet(rhs, i - 1 | 0) ? 0 : 1;
          var costReplace = cost[j - 1 | 0] + match | 0;
          var costInsert = cost[j] + 1 | 0;
          var costDelete = newCost[j - 1 | 0] + 1 | 0;
          var tmp_4 = newCost;
          // Inline function 'kotlin.math.min' call
          // Inline function 'kotlin.math.min' call
          var a = Math.min(costInsert, costDelete);
          tmp_4[j] = Math.min(a, costReplace);
        }
         while (inductionVariable_0 < lhsLength);
      var swap = cost;
      cost = newCost;
      newCost = swap;
    }
     while (inductionVariable < rhsLength);
  return cost[lhsLength - 1 | 0];
}
var TextQueryClass;
function TextQuery() {
  if (TextQueryClass === VOID) {
    class $ {
      constructor(exact, loose, reject) {
        var tmp;
        if (exact === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = exact;
        }
        exact = tmp;
        var tmp_0;
        if (loose === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_0 = emptySet();
        } else {
          tmp_0 = loose;
        }
        loose = tmp_0;
        var tmp_1;
        if (reject === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_1 = emptySet();
        } else {
          tmp_1 = reject;
        }
        reject = tmp_1;
        this.z3r_1 = exact;
        this.a3s_1 = loose;
        this.b3s_1 = reject;
      }
      c3s(input, off) {
        var words = split(input, charArrayOf([_Char___init__impl__6a9atx(32), _Char___init__impl__6a9atx(10), _Char___init__impl__6a9atx(9)]));
        var tmp;
        var tmp_0;
        var tmp0 = this.z3r_1;
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.all' call
          var tmp_1;
          if (isInterface(tmp0, Collection())) {
            tmp_1 = tmp0.i1();
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (!contains(input, element, true)) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
          }
          tmp$ret$0 = true;
        }
        if (tmp$ret$0) {
          var tmp0_0 = this.a3s_1;
          var tmp$ret$2;
          $l$block_4: {
            // Inline function 'kotlin.collections.all' call
            var tmp_2;
            if (isInterface(tmp0_0, Collection())) {
              tmp_2 = tmp0_0.i1();
            } else {
              tmp_2 = false;
            }
            if (tmp_2) {
              tmp$ret$2 = true;
              break $l$block_4;
            }
            var _iterator__ex2g4s_0 = tmp0_0.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var element_0 = _iterator__ex2g4s_0.o1();
              var tmp$ret$3;
              $l$block_3: {
                // Inline function 'kotlin.collections.any' call
                var tmp_3;
                if (isInterface(words, Collection())) {
                  tmp_3 = words.i1();
                } else {
                  tmp_3 = false;
                }
                if (tmp_3) {
                  tmp$ret$3 = false;
                  break $l$block_3;
                }
                var _iterator__ex2g4s_1 = words.m1();
                while (_iterator__ex2g4s_1.n1()) {
                  var element_1 = _iterator__ex2g4s_1.o1();
                  var tmp_4;
                  if (termShouldUseFuzzySearch(element_0)) {
                    // Inline function 'kotlin.text.lowercase' call
                    // Inline function 'kotlin.js.asDynamic' call
                    var tmp_5 = element_0.toLowerCase();
                    // Inline function 'kotlin.text.lowercase' call
                    // Inline function 'kotlin.js.asDynamic' call
                    var tmp$ret$7 = element_1.toLowerCase();
                    tmp_4 = levenshtein(this, tmp_5, tmp$ret$7) <= off;
                  } else {
                    tmp_4 = contains(input, element_0, true);
                  }
                  if (tmp_4) {
                    tmp$ret$3 = true;
                    break $l$block_3;
                  }
                }
                tmp$ret$3 = false;
              }
              if (!tmp$ret$3) {
                tmp$ret$2 = false;
                break $l$block_4;
              }
            }
            tmp$ret$2 = true;
          }
          tmp_0 = tmp$ret$2;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          var tmp0_1 = this.b3s_1;
          var tmp$ret$10;
          $l$block_6: {
            // Inline function 'kotlin.collections.none' call
            var tmp_6;
            if (isInterface(tmp0_1, Collection())) {
              tmp_6 = tmp0_1.i1();
            } else {
              tmp_6 = false;
            }
            if (tmp_6) {
              tmp$ret$10 = true;
              break $l$block_6;
            }
            var _iterator__ex2g4s_2 = tmp0_1.m1();
            while (_iterator__ex2g4s_2.n1()) {
              var element_2 = _iterator__ex2g4s_2.o1();
              if (contains(input, element_2, true)) {
                tmp$ret$10 = false;
                break $l$block_6;
              }
            }
            tmp$ret$10 = true;
          }
          tmp = tmp$ret$10;
        } else {
          tmp = false;
        }
        return tmp;
      }
      toString() {
        return 'TextQuery(exact=' + toString_0(this.z3r_1) + ', loose=' + toString_0(this.a3s_1) + ', reject=' + toString_0(this.b3s_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.z3r_1);
        result = imul(result, 31) + hashCode(this.a3s_1) | 0;
        result = imul(result, 31) + hashCode(this.b3s_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof TextQuery()))
          return false;
        if (!equals(this.z3r_1, other.z3r_1))
          return false;
        if (!equals(this.a3s_1, other.a3s_1))
          return false;
        if (!equals(this.b3s_1, other.b3s_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'TextQuery', TextQuery);
    TextQueryClass = $;
  }
  return TextQueryClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instanceyc5x9yqxshdb,
};
//endregion

//# sourceMappingURL=TextQuery.mjs.map
